import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "This app has streamlined my invoicing process completely. It saves me hours every month!",
      author: "DS, Dental Hygienist"
    },
    {
      quote: "Coooly has made my billing so much easier. I can't imagine going back to Word and Excel.",
      author: "JS, Dental Nurse"
    },
    {
      quote: "The automated calculations are a game-changer. Highly recommend this app!",
      author: "EJ, Dental Hygienist"
    },
    {
      quote: "The expense tracking with receipt upload is brilliant. Made my tax return so much easier this year!",
      author: "MR, Dental Hygienist"
    },
    {
      quote: "Love how I can snap photos of parking receipts and mileage is calculated automatically. Saves so much paperwork!",
      author: "KL, Dental Hygienist"
    },
    {
      quote: "Finding locum work nearby has never been easier. The job search shows exactly what's in my area.",
      author: "TH, Dental Hygienist"
    }
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleNextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <Box sx={{ py: 3, mb: 4 }}>
      <Typography 
        variant="h4" 
        component="h2" 
        align="center" 
        sx={{ color: '#A78BFA', mb: 3, fontWeight: 'bold' }} 
      >
        What Our Users Say
      </Typography>
      
      <Card sx={{ 
        bgcolor: '#2A2A3E', 
        p: 3, 
        maxWidth: 'md', 
        mx: 'auto', 
        border: '1px solid rgba(138, 43, 226, 0.2)', 
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <IconButton 
            onClick={handlePrevTestimonial} 
            sx={{ color: '#9370DB', '&:hover': { color: '#A78BFA' } }}
          >
            <ArrowBackIcon />
          </IconButton>
          
          <Box sx={{ flex: 1, px: 2 }}>
            <Typography 
              sx={{ color: 'grey.300', fontStyle: 'italic', mb: 1 }}
            >
              "{testimonials[currentTestimonial].quote}"
            </Typography>
            <Typography 
              sx={{ color: '#9370DB', fontWeight: 'medium', fontSize: '0.875rem' }}
            >
              {testimonials[currentTestimonial].author}
            </Typography>
          </Box>
          
          <IconButton 
            onClick={handleNextTestimonial} 
            sx={{ color: '#9370DB', '&:hover': { color: '#A78BFA' } }}
          >
            <ArrowForwardIcon />
          </IconButton>
        </Box>
      </Card>
    </Box>
  );
};

export default Testimonials;
